import React from 'react';
import {useHubspotChatIntegration} from '@/hooks/useHubspotChatIntegration';

export function HubspotChatWidget() {
    // The actual initialization and UI injection is done within the hook which first queries the
    // backend for additional data and then injects the chat bubble into the page asynchronously
    useHubspotChatIntegration();
    return (<></>);
}
